/* eslint-disable react/prop-types */
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Menu, Icon } from 'antd';

function Navigation(props) {
  return (
    <Menu
      theme="dark"
      mode="inline"
      defaultOpenKeys={['sb-users']}
      selectedKeys={[props.location.pathname]}
    >
      <Menu.Item key="/dashboard">
        <Link to="/dashboard"><span><Icon type="unordered-list" /><span>Dashboard</span></span></Link>
      </Menu.Item>
      <Menu.SubMenu key="sb-users" title={<span><Icon type="user" /><span>Users</span></span>}>
        <Menu.Item key="/admins">
          <Link to="/admins">Admins</Link>
        </Menu.Item>
        <Menu.Item key="/clients">
          <Link to="/clients">Clients</Link>
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.Item key="/categories">
        <Link to="/categories"><span><Icon type="unordered-list" /><span>Categories</span></span></Link>
      </Menu.Item>
      <Menu.Item key="/types">
        <Link to="/types"><span><Icon type="profile" /><span>Types</span></span></Link>
      </Menu.Item>
      <Menu.Item key="/cards">
        <Link to="/cards"><span><Icon type="file-image" /><span>Cards</span></span></Link>
      </Menu.Item>
      <Menu.Item key="/places">
        <Link to="/places"><span><Icon type="bank" /><span>Places</span></span></Link>
      </Menu.Item>
      <Menu.Item key="/reports">
        <Link to="/reports"><span><Icon type="file-text" /><span>Reports</span></span></Link>
      </Menu.Item>
      <Menu.Item key="/claim-business/request">
        <Link to="/claim-business/request"><span><Icon type="file-text" /><span>Claim Business</span></span></Link>
      </Menu.Item>
    </Menu>
  );
}

export default withRouter(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js